import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RejectOrderPageRoutingModule } from './reject-order-routing.module';

import { RejectOrderPage } from './reject-order.page';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SharedModule, RejectOrderPageRoutingModule],
  declarations: [RejectOrderPage]
})
export class RejectOrderPageModule {}
